import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchQuery: '',
};

const AgentsSlice = createSlice({
  name: 'agents',
  initialState,
  reducers: {
    setSearchQuery(state, action) {
      state.searchQuery = action.payload;
    },
  },
});

export const { setSearchQuery } = AgentsSlice.actions;
export default AgentsSlice.reducer;
